import React from "react";

const JOB_STATUS = {
  DRAFT: { label: "Draft", cls: "bg-slate-100 text-slate-600" },
  OPEN: { label: "Terbuka", cls: "bg-emerald-100 text-emerald-700" },
  ASSIGNED: { label: "Terisi", cls: "bg-indigo-100 text-indigo-700" },
  IN_PROGRESS: { label: "Berjalan", cls: "bg-amber-100 text-amber-700" },
  COMPLETED: { label: "Selesai", cls: "bg-blue-100 text-blue-700" },
  CANCELLED: { label: "Dibatalkan", cls: "bg-rose-100 text-rose-700" },
};

const APP_STATUS = {
  PENDING: { label: "Menunggu", cls: "bg-amber-100 text-amber-700" },
  ACCEPTED: { label: "Diterima", cls: "bg-emerald-100 text-emerald-700" },
  REJECTED: { label: "Ditolak", cls: "bg-rose-100 text-rose-700" },
  CANCELLED: { label: "Dibatalkan", cls: "bg-slate-100 text-slate-600" },
};

const REPORT_STATUS = {
  OPEN: { label: "Baru", cls: "bg-amber-100 text-amber-700" },
  REVIEWING: { label: "Ditinjau", cls: "bg-blue-100 text-blue-700" },
  RESOLVED: { label: "Selesai", cls: "bg-emerald-100 text-emerald-700" },
  DISMISSED: { label: "Diabaikan", cls: "bg-slate-100 text-slate-600" },
};

export function StatusBadge({ status, kind = "job", testId }) {
  const map = kind === "app" ? APP_STATUS : kind === "report" ? REPORT_STATUS : JOB_STATUS;
  const s = map[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
